import { pickBy } from "lodash";
import { HttpError } from "@nestia/fetcher";
import api from "@api";
import { getConnection } from "@app/sdk";

import { type PageOf } from "@shared/types/misc";
import { ItemSchema, type Item } from "@entities/item";

export interface Filters {
  categoryName?: string;
  lowStock?: boolean;
  pageSize?: number;
  search?: string;
  page?: number;
  populateStockHistory?: boolean;
}

const defaultResponse: PageOf<Item> = { rows: [], totalPages: 1 };

export const getAllItems = async (
  filters: Filters = {},
): Promise<PageOf<Item>> => {
  try {
    const response = await api.functional.items.getItems(
      getConnection(),
      pickBy(filters, Boolean),
    );

    const page = response?.responseObject;

    if (!page) return defaultResponse;

    return { ...page, rows: page.rows.map((row) => ItemSchema.parse(row)) };
  } catch (e) {
    if (e instanceof HttpError) {
      return defaultResponse;
    }

    throw e;
  }
};
